import PropTypes from 'prop-types'
import { StyleSheet, css } from 'aphrodite'
import { COLOR_PRIMARY__TEXT } from '../../lib/colors'
import React from 'react'
import UIInputError from './UIInputError'

const UICheckbox = React.forwardRef(function UICheckbox(
  {
    disabled = false,
    label,
    errorMessage,
    dynamicStyle,
    checkBoxStyle,
    children,
    ...props
  },
  ref
) {
  const isInError = !!errorMessage

  return (
    <>
      <div className={css(styles.container, dynamicStyle)}>
        <input
          type="checkbox"
          className={css(styles.default, checkBoxStyle)}
          disabled={disabled}
          ref={ref}
          {...props}
        />
        {label}
        {children}
      </div>
      {isInError && <UIInputError errorMessage={errorMessage} />}
    </>
  )
})

const styles = StyleSheet.create({
  container: {
    width: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 500,
    margin: '3px 0px',
    color: COLOR_PRIMARY__TEXT,
    ':hover': {
      cursor: 'pointer',
    },
  },
  default: {
    ':hover': {
      cursor: 'pointer',
    },
  },
})
UICheckbox.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
  errorMessage: PropTypes.string,
  dynamicStyle: PropTypes.node,
  checkBoxStyle: PropTypes.node,
}

export default UICheckbox
